import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Pipe, PipeTransform } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';
import { CeqAdjust } from 'src/app/ceq/common/models/AdjustUnit.Model';
import { Unit } from 'src/app/ceq/common/models/Unit.Model';
import { AdjustService } from '../adjust.service';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';

import Swal from 'sweetalert2';
import { toNumber } from 'lodash';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { PurchaseService } from 'src/app/ceq/purchase/purchase.service';
import { MessagingService } from 'src/app/services/messaging/messaging.service';



@Component({
  selector: 'app-adjust-ceve-cut-v2',
  templateUrl: './adjust-ceve-cut-v2.component.html',
  styleUrls: ['./adjust-ceve-cut-v2.component.scss']
})
export class AdjustCeveCutV2Component implements OnInit, OnDestroy {
  datepipe: any;

  constructor(public globalFunctionService: GlobalFunctionsService,
    private db: AngularFireDatabase,
    private adjustServive: AdjustService,
    private settings: SettingsService,
    private purchaseService: PurchaseService,
    private notificationService: MessagingService
  ) { }


  //propiedad
  @Input() SelectedUnit: Unit;
  @Input() ActiveAdjust: CeqAdjust;
  @Output("OnAdjustCanceled") OnAdjustCanceled: EventEmitter<any> = new EventEmitter();


  //variables generales
  userActivities: string[];
  user: UserLogin;
  isSaving: boolean;


  //variables de caratula
  adjHistory: boolean = false;
  adjWebRunning: boolean;
  adjPTRunning: boolean = false;
  adjApkRunning: boolean;
  adjustLines: AdjustUnitCutLine[] = [];
  canEditAdjust: boolean = false;
  showCancelPT: boolean = false;
  //variables de temporizador de compulsa
  timer: any;
  adjLapTime;
  currentDateTime: Date = new Date();
  hours: string = "0";
  minutes: string = "0";
  seconds: string = "0";
  countdownMaxTime: string = '2:30:00';
  countdown15Enabled: boolean = false;
  countdown30Enabled: boolean = false;
  countdown45Enabled: boolean = false;
  countdown60Enabled: boolean = false;
  showCountdownBox: boolean = false;
  showButtonPT: boolean = false;
  loadDataPT: boolean = false;

  //variables firebase
  eventsSub: Subscription;
  towersSub: Subscription;
  userInAdjustPage: boolean = false;
  gettingDetail: boolean = false;
  firebaseEvents: AngularFireList<FirebaseEvent>;
  firebaseTowers: AngularFireList<FirebaseTowers>;


  //Variables de botones 

  showWebPhisical: boolean = true;
  showApkPhisical: boolean = true;

  //variables de botones de guardado
  displaySave: boolean;
  enableSave: boolean;
  displaySign: boolean;
  enableSign: boolean;
  displayReopen: boolean;
  enableReopen: boolean;
  displaySaveAPK: boolean;
  enableSaveAPK: boolean;
  displayAttch: boolean;

  adjustMoveDateSuccess: boolean = false;
  AdjustMoveDate: any;


  async ngOnInit(): Promise<void> {
    this.userInAdjustPage = true;
    //obtengo los datos del usuario
    this.user = this.settings.getUser();
    this.userActivities = this.settings.getUserAccess();

    this.globalFunctionService.messageToast('Cargando compulsa.', 'loading');

    //obtengo el detalle de la caratura
    await this.ValidateAdjustHeader();

    this.globalFunctionService.messageToast('Datos cargados correctamente.', 'success');
    this.showButtonPT = this.userActivities.includes('LOADEFPT');
  }

  ngOnDestroy(): void {
    this.userInAdjustPage = false;
    this.stopTimer();
    this.CloseFirebaseConnection();
  }

  //#region Alertas

  /**Muestra alerta de carga */
  async showLoading(title: string, message: string) {
    this.hideLoading();
    await this.globalFunctionService.messageBimbo(message, 'loading', title);
  }

  /**Oculta la alerta de cargando */
  hideLoading() {
    Swal.close();
  }

  /**Muestra mensaje de error */
  async showErrorMessage(err) {
    if (err?.error?.Message !== '' && err?.error?.Message !== undefined) {
      await this.globalFunctionService.messageBimbo(err.error.Message, 'warning', 'Compulsa');
    }
    else if (err?.message !== '' && err?.message !== undefined) {
      await this.globalFunctionService.messageBimbo(err.Message, 'warning', 'Compulsa');
    }
    else {
      await this.globalFunctionService.messageBimbo(err, 'warning', 'Compulsa');
    }
  }

  //#endregion


  //#region Caratula

  /**Valida el encabezado de la caratula */
  async ValidateAdjustHeader(): Promise<void> {
    if (this.ActiveAdjust.Status == "APPLYED" || this.ActiveAdjust.Status == "LAPSED" || this.ActiveAdjust.Status == "CLOSED" || this.ActiveAdjust.Status == "CANCELED") {
      this.showLoading('Cargando caratula', 'por favor espere');
      await this.loadCutData();
    }
    else if (this.ActiveAdjust.Status == "CREATED") {
      this.hideLoading();
      this.showLoading('Cargando caratula', 'por favor espere');
      await this.loadCutData();
      await this.startTimer();
      this.evaluateMAxCountDown();

    }
    else {
      this.hideLoading();
      this.globalFunctionService.messageToast(`Inventario cargado.`, 'success');
      await this.loadCutData();
      await this.startTimer();
      this.evaluateMAxCountDown();
    }


  }

  /**Obtiene el encabezado de la caratula */
  async loadCutData() {
    await this.adjustServive
      .getAdjustInventoryV2(this.ActiveAdjust.AdjustCode).toPromise().then(async (x) => {

        //Armo lineas de la caratula
        await this.buildAdjustLines(x);

        this.hideLoading();
        await this.globalFunctionService.messageBimbo('Prerrequisitos en sistemas completos, durante la ventana de tiempo de certificación no se podrán realizar transacciones.', 'success', 'Compulsa');

        if (this.ActiveAdjust.Status == 'APK') {
          await this.adjApk(false);
        }
        else if (this.ActiveAdjust.Status == 'COUNTED') {
          await this.adjApk(false);
        }

        this.validateAdjustStatus();

      })
      .catch((err) => {
        console.log(err);
      });


    //obtengo la fecha de la ultima toma de inventario
    await this.adjustServive.getInitialAdjusMoveDate(this.SelectedUnit.UnitId).toPromise().then(resp => {
      console.log(resp);
      this.AdjustMoveDate = resp;
      this.adjustMoveDateSuccess = true;
    })
      .catch(err => {
        this.adjustMoveDateSuccess = false;
        console.error(err);
      });
  }

  /**Agrega las lineas de la compulsa*/
  async buildAdjustLines(lines: AdjustUnitCutLine[]): Promise<void> {

    let tmpLines = lines;

    //muevo los hijos a los padres
    let parentLines = tmpLines.filter(x => x.ParentId == 0);
    let childLines = tmpLines.filter(x => x.ParentId != 0);

    for (let i = 0; i < parentLines.length; i++) {
      parentLines[i].Childrens = childLines.filter(x => x.ParentId == parentLines[i].LineNumber);
      //Si hay un hijo que sea editable por defecto el padre se muestra expandido
      parentLines[i].Collapsed = !parentLines[i].Childrens.some(x => x.Detail.some(y => y.IsEditable));
    }

    //asigno las lineas armadas a la vista
    this.adjustLines = parentLines;

  }

  /**Recarga la informacion de la compulsa */
  async reloadAdjust() {
    await this.adjustServive.getAdjust(this.ActiveAdjust.AdjustCode).toPromise().then(async resp => {
      this.ActiveAdjust = resp;
      await this.adjustServive.getAdjustInventoryV2(this.ActiveAdjust.AdjustCode)
        .toPromise()
        .then(async (x) => {
          await this.buildAdjustLines(x);
          this.updateTotals();
          this.validateAdjustStatus();
        });

    })
      .catch(err => {
        this.showErrorMessage(err);
      });
  }

  async reloadDetail() {
    await this.adjustServive.getAdjustInventoryV2(this.ActiveAdjust.AdjustCode).toPromise().then(async (x) => {
      await this.buildAdjustLines(x);
      this.updateTotals();
    });
  }


  /**Valida el estatus de la compusla  */
  async validateAdjustStatus() {
    console.log('status', this.ActiveAdjust.Status);
    let counter = this.userActivities.includes('ADJINVWEB');
    let certifier = this.userActivities.includes('ADJCHKCERT');
    let onlyViewAdj = this.userActivities.includes("ADJVIEWWEB");

    this.canEditAdjust = false;
    this.showWebOptions();
    this.disableWebOptions();
    if (this.ActiveAdjust.Status == "CREATED") {
      //si el conteo de equipo en web no esta activo no se muestran las opciones
      if (this.adjWebRunning) {
        //when adjust is started or has ben reopened
        if (counter && !onlyViewAdj) {
          //Actividad de contador de inventario en web    

          this.canEditAdjust = true;
          this.enableSave = true;
          this.enableSign = true;
          this.displayAttch = false;
        }
      }
      else {
        this.hideWebOptions();
      }
    }
    if (this.ActiveAdjust.Status == "SAVED") {
      this.adjWebRunning = true;
      // this.enableClose = true;
      this.displayAttch = false;

      if (counter && !onlyViewAdj) {
        //Actividad de contador de inventario en web    

        this.canEditAdjust = true;
        this.enableSign = true;
        this.enableSave = true;
      }
    }
    if (this.ActiveAdjust.Status == "REOPENED") {
      this.adjWebRunning = true;
      this.displayAttch = false;

      if (counter && !onlyViewAdj) {
        //Actividad de contador de inventario en web    

        this.canEditAdjust = true;
        this.enableSave = true;
        this.enableSign = true;
      }
    }
    if (this.ActiveAdjust.Status == "SIGNED") {
      this.adjWebRunning = true;
      this.enableSign = true;
      this.enableReopen = true;
      this.displayAttch = true;

      if (counter) {
        this.enableSign = false;
        this.enableReopen = false;
        this.displayAttch = false;
      }

      //si ambos usuarios firmaron ya se aplica la compulsa
      if (this.ActiveAdjust.CertifierUser !== '' && this.ActiveAdjust.CertifiedUser !== '') {
        this.applyAdjust();
      }

    }
    if (this.ActiveAdjust.Status == "SIGNEDAPK") {
      if (counter && !onlyViewAdj) {//Actividad de contador de inventario en web    
        if (!this.isSaving) {
          this.applyAdjustAPK();
        }
      }
      else { //Usuario certificador de compulsa 
        this.hideLoading();
        this.CloseFirebaseConnection();
        this.adjWebRunning = false;
        this.adjApkRunning = false;
        this.adjPTRunning = false;
        this.isSaving = false;
        await this.globalFunctionService.messageBimbo("Compulsa firmada correctamente, el Ajuste de inventario se aplicara en el ordenador del usuario contador.", 'success', 'Compulsa')
          .then(() => {
            this.OnAdjustCanceled.emit();
          });
      }
    }
    if (this.ActiveAdjust.Status == "CLOSED") {
      this.adjWebRunning = false;
      this.adjHistory = true;
      this.hideWebOptions();
    }
    if (this.ActiveAdjust.Status == "APPLYED") {
      this.adjWebRunning = false;
      this.adjHistory = true;
      this.hideWebOptions();
    }
    if (this.ActiveAdjust.Status == "LAPSED") {
      this.adjWebRunning = false;
      this.adjHistory = true;
      this.hideWebOptions();
    }
    if (this.ActiveAdjust.Status == "CANCELED") {
      this.adjWebRunning = false;
      this.adjHistory = true;
      this.hideWebOptions();
    }
    if (this.ActiveAdjust.Status == "APK") {
      if (counter && !onlyViewAdj) {
        //Actividad de contador de inventario en web    

        this.canEditAdjust = false;
        this.displaySaveAPK = true;
        this.enableSaveAPK = true;
      }
      this.hideWebOptions();
      this.adjApk(false);

    }
    if (this.ActiveAdjust.Status == "PT") {

      this.hideWebOptions();
      this.adjPT();

    }

  }

  /**Inicia el conteo en web */
  async adjWeb() {
    await this.adjustServive.updateEventStatus(this.SelectedUnit.UnitId, this.ActiveAdjust.AdjustCode, 'COUNTING').toPromise().then(resp => {
      this.adjWebRunning = true;
      this.validateAdjustStatus();
    })
      .catch(error => {

      });
  }

  /**Finaliza el conteo en web  */
  async cancelAdjweb() {
    await this.globalFunctionService.messageBimbo(`¿Desea cancelar el conteo físico?`, 'question2', 'Compulsa')
      .then(async (result) => {
        if (result) {
          this.adjWebRunning = false;
          this.hideWebOptions();
          this.enableSave = false;
          this.canEditAdjust = false;
          this.displayAttch = false;
          
          this.showButtonPT = this.userActivities.includes('LOADEFPT');
          this.adjPTRunning = false;

          this.showLoading('Cargando inventario', 'Por favor espere');
          await this.reloadDetail();
          this.hideLoading();
        }
      });

  }
  /**Inicia el conteo en PT */
  async adjPT() {
    await this.showLoading('Cargando compulsa PT', 'Por favor espere');
    await this.adjustServive.getAjustDatePT(this.SelectedUnit.UnitId).toPromise().then(async resp => {
      this.adjPTRunning = true;
      if (!resp.NotData) {
        this.loadDataPT = true;
        let latest_date = moment(resp.Value).format('DD-MM-YYYY')
        this.showCancelPT = true;
        this.hideLoading();
        await this.globalFunctionService.messageBimbo(`El conteo físico PT que desea cargar es de la compulsa PT de la fecha ${latest_date} ¿Desea continuar?`, 'question2', 'Compulsa')
          .then(async (result) => {
            if (result) {
              this.showLoading('Cargando inventario', 'Por favor espere');
              await this.adjustServive.validateAvailableConnetions(2).toPromise().then(async (resp) => {
                let adjustCon = {
                  Org: this.user.Org,
                  AdjustCode: this.ActiveAdjust.AdjustCode,
                  ConnChannel: 'Event',
                  FirebaseKey: this.user.Token.length > 200 ? this.user.Token.substring(0, 199) : this.user.Token,
                  ConnUser: this.user.Email
                };
                let towerCon = {
                  Org: this.user.Org,
                  AdjustCode: this.ActiveAdjust.AdjustCode,
                  ConnChannel: 'Tower',
                  FirebaseKey: this.user.Token.length > 200 ? this.user.Token.substring(0, 199) : this.user.Token,
                  ConnUser: this.user.Email
                };
                await this.adjustServive.addConnection(adjustCon).toPromise().then(() => {

                })
                  .catch(err => {
                    this.showErrorMessage(err);
                  });
                await this.adjustServive.addConnection(towerCon).toPromise().then(() => {

                })
                  .catch(err => {
                    this.showErrorMessage(err);
                  });


                this.ActiveAdjust.Status = "PT"
                this.OpenFirebaseConnection();
                await this.adjustServive.startAdjustPT(this.SelectedUnit.UnitId, this.ActiveAdjust.AdjustCode).toPromise().then(async resp => {
                  await this.reloadAdjust();
                  await this.saveAdjustApk();

                  this.hideLoading();
                })
                  .catch(async error => {
                    console.error(error);
                    this.hideLoading();
                    this.adjPTRunning = false;
                    await this.globalFunctionService.messageBimbo("Error al obtener los datos de compulsa PT", 'error', 'Compulsa');
                  });
              }).catch(async err => {
                this.showErrorMessage(err);
                this.hideLoading();
                this.adjPTRunning = false;
                await this.globalFunctionService.messageBimbo("Error al obtener los datos de compulsa PT", 'error', 'Compulsa');
              });
            }
          })
      } else {
        this.hideLoading();
        this.loadDataPT = false;
        await this.globalFunctionService.messageBimbo(`No hay compulsas PT publicadas ¿Desea generar una captura web para editar los valores Equipo Físico con PT?`, 'question2', 'Compulsa')
          .then(async (result) => {
            if (result) {
              this.adjWeb();
            }
            else{
              this.adjPTRunning = false;
            }
          });
      }

    }).catch(err => {
      console.log(err);
      this.showErrorMessage(err.error);
      this.adjPTRunning = false;
    });
  }


  /**Inicia el conteo en APK */
  async adjApk(reestartCount: boolean = true) {
    this.showLoading('Cargando inventario', 'Por favor espere');

    await this.adjustServive.validateAvailableConnetions(2).toPromise().then(async (resp) => {
      let adjustCon = {
        Org: this.user.Org,
        AdjustCode: this.ActiveAdjust.AdjustCode,
        ConnChannel: 'Event',
        FirebaseKey: this.user.Token.length > 200 ? this.user.Token.substring(0, 199) : this.user.Token,
        ConnUser: this.user.Email
      };
      let towerCon = {
        Org: this.user.Org,
        AdjustCode: this.ActiveAdjust.AdjustCode,
        ConnChannel: 'Tower',
        FirebaseKey: this.user.Token.length > 200 ? this.user.Token.substring(0, 199) : this.user.Token,
        ConnUser: this.user.Email
      };
      await this.adjustServive.addConnection(adjustCon).toPromise().then(() => {

      })
        .catch(err => {
          this.showErrorMessage(err);
        });
      await this.adjustServive.addConnection(towerCon).toPromise().then(() => {

      })
        .catch(err => {
          this.showErrorMessage(err);
        });


      this.ActiveAdjust.Status = "APK"
      this.OpenFirebaseConnection();

      if (reestartCount) {

        await this.adjustServive.startApkAdjustV2(this.ActiveAdjust.AdjustCode).toPromise().then(async resp => {
          await this.reloadAdjust();
          await this.saveAdjustApk();

          this.hideLoading();
        })
          .catch(error => {
            console.error(error);
            this.hideLoading();
          });
      }
      else {
        this.adjApkRunning = true;
        this.hideWebOptions();
        if (this.userActivities.includes('ADJINVWEB') && !this.userActivities.includes("ADJVIEWWEB")) {
          //Actividad de contador de inventario en web    

          this.canEditAdjust = false;
          this.displaySaveAPK = true;
          this.enableSaveAPK = true;
        }
      }
      this.hideLoading();
    })
      .catch(err => {
        this.showErrorMessage(err);
        this.hideLoading();

        this.adjWebRunning = false;
        this.adjApkRunning = false;
        this.adjPTRunning = false;
      });


  }

  /**Finaliza el conteo en APK */
  async cancelAdj(tipo: string) {
    // Swal.fire({
    //   text: `¿Desea cancelar el conteo fisico en ${tipo}?`,
    //   icon: 'question',
    //   showCancelButton: true,
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: '<i class="fa fa-thumbs-up"></i> &nbsp; Si',
    //   cancelButtonText: '<i class="fa fa-thumbs-down"></i> &nbsp; No',
    //   backdrop: `rgba(0,157,210,0.5)`,
    //   allowOutsideClick: false
    // })
    await this.globalFunctionService.messageBimbo(`¿Desea cancelar el conteo físico en ${tipo}?`, 'question2', 'Compulsa')
      .then(async (result) => {
        if (result) {

          this.showLoading('Cargando inventario', 'Por favor espere');

          await this.adjustServive.deleteConnection(this.ActiveAdjust.AdjustCode).toPromise().then(async () => {

            this.CloseFirebaseConnection();
            this.displaySaveAPK = false;
            this.enableSaveAPK = false;
            this.adjApkRunning = false;
            this.adjPTRunning = false;
            this.ActiveAdjust.Status = "CREATED";

            await this.adjustServive.cancelApkAdjustV2(this.ActiveAdjust.AdjustCode).toPromise().then(async resp => {
              await this.reloadAdjust();
              this.hideLoading();
            })
              .catch(error => {
                this.showErrorMessage(error);
                this.hideLoading();
              });
          })
            .catch(err => {
              this.showErrorMessage(err);
              this.hideLoading();
            });
        }
        this.hideLoading();

      });

  }

  /**Cancela la compulsa */
  async cancelAdjust() {
    await this.globalFunctionService.messageBimbo(`¿Desea cancelar la compulsa?, Esto concluira la compulsa activa.`, 'question2', 'Compulsa')
      .then(async (result) => {
        if (result) {
          let comment = await this.requestCancelComment();
          if (comment != 'CANCELADJ' && comment != '') {
            this.adjWebRunning = false;
            this.adjApkRunning = false;
            this.adjPTRunning = false;

            await this.globalFunctionService.messageBimbo('Cancelando compulsa, por favor espere...', 'loading', 'Compulsa');
            await this.adjustServive.cancelAdjust(this.ActiveAdjust.AdjustCode, comment).toPromise()
              .then(resp => {
                this.hideLoading();
                this.OnAdjustCanceled.emit();
              })
              .catch(async err => {
                this.hideLoading();
                console.log(err);
                await this.globalFunctionService.messageBimbo(err.error.Message, 'warning', 'Compulsa');
              });
          }
        }
      });
  }

  /**Comentario de cancelacion de compulsa */
  async requestCancelComment(): Promise<string> {
    let comment = 'CANCELADJ';
    await this.globalFunctionService.messageBimbo('Debe ingresar un comentario que justifique la cancelacion de la compulsa', 'text', 'Comentario de cancelacion')
      .then(async result => {
        if (result) {
          comment = result;
        }
        else {
          await this.globalFunctionService.messageBimbo('Debe ingresar el comentario de cancelacion.', 'warning', 'Compulsa');
        }
      });
    return comment;
  }

  /**Confirmacion de firma de compulsa */
  async confirmSignAdjust(): Promise<boolean> {
    // return await Swal.fire({
    //   text: `¿Desea firmar la compulsa, esto finalizará el conteo fisico ?`,
    //   icon: 'question',
    //   showCancelButton: true,
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: '<i class="fa fa-thumbs-up"></i> &nbsp; Si',
    //   cancelButtonText: '<i class="fa fa-thumbs-down"></i> &nbsp; No',
    //   backdrop: `rgba(0,157,210,0.5)`,
    //   allowOutsideClick: false
    // })
    return await this.globalFunctionService.messageBimbo('¿Desea firmar la compulsa? esto finalizará el conteo fisico.', 'question2', 'Confirmación')
      .then(async (result) => {
        return result;
      });

  }

  /**Aplica la compulsa con conteo en web */
  async applyAdjust() {
    this.showLoading('Aplicando compulsa', 'Por favor espere.');
    await this.adjustServive.applyAdjustV2(this.ActiveAdjust.AdjustCode).toPromise().then(() => {
      this.hideLoading();
      this.globalFunctionService.messageBimbo("Ajuste de inventario realizado con exito", "success", "Compulsa");

      this.OnAdjustCanceled.emit();
    })
      .catch(async err => {
        console.log(err);
        await this.globalFunctionService.messageBimbo(err.error.Message, "warning", "Compulsa");
      });
  }

  /**Aplica la compulsa con conteo en apk */
  async applyAdjustAPK() {
    if (this.isSaving) { return; }
    this.isSaving = true;

    this.showLoading('Aplicando compulsa', 'Por favor espere.');

    let newInv = this.adjustLines.filter(x => x.LineNumber != 0);
    this.adjustLines.forEach(line => {
      newInv.push(...line.Childrens);
    });
    await this.adjustServive.saveAdjustV2(this.ActiveAdjust.AdjustCode, newInv).toPromise().then(async resp => {

      await this.adjustServive.applyAdjustV2(this.ActiveAdjust.AdjustCode).toPromise().then(async resp => {

        this.ActiveAdjust.Status = "APPLYED";
        this.adjWebRunning = false;
        this.adjApkRunning = false;
        this.adjPTRunning = false;
        this.hideLoading();
        this.CloseFirebaseConnection();
        await this.globalFunctionService.messageBimbo('Ajuste de inventario realizado con exito', "success", "Compulsa");
        this.isSaving = false;
        this.OnAdjustCanceled.emit();

      })
        .catch(async err => {
          this.isSaving = false;
          console.error(err);
          await this.globalFunctionService.messageBimbo('La compulsa se guardo correctamente pero no se pudieron aplicar los movimientos del inventario, por favor vuelva a intentar', "warning", "Compulsa");
        });
    })
      .catch(async err => {
        this.isSaving = false;
        console.error(err);
        await this.globalFunctionService.messageBimbo(err.error.Message, "warning", "Compulsa");
      });
  }

  /**Caduca la compulsa  */
  async lapseAdjust() {
    this.showLoading('Caducando compulsa', 'Se agoto el tiempo de compulsa, pasara a estatus caducada');

    this.adjWebRunning = false;
    this.adjApkRunning = false;
    this.adjPTRunning = false;

    await this.adjustServive.lapseAdjust(this.ActiveAdjust.AdjustCode).toPromise().then(resp => {
      this.CloseFirebaseConnection();
      this.adjWebRunning = false;
      this.adjApkRunning = false;
      this.adjPTRunning = false;
      this.hideLoading();
      this.OnAdjustCanceled.emit();
    })
      .catch(err => {
        console.log(err);
        this.hideLoading();
        this.globalFunctionService.messageBimbo(err.error.Message, 'warning', 'Compulsa');
      });



    this.hideLoading();
  }


  //#endregion


  //#region Conteo en web


  //#region Botones guardar 

  showWebOptions() {
    this.displaySave = true;
    this.displaySign = true;
    this.displayReopen = true;
  }

  /**Oculta los botones de guardado */
  hideWebOptions() {
    this.displaySave = false;
    this.displaySign = false;
    this.displayReopen = false;
  }

  /**Deshabilita las botones de guardado*/
  disableWebOptions() {
    this.enableSave = false;
    this.enableSign = false;
    this.enableReopen = false;
  }

  /**Guarda las cantidades del conteo en web de la compulsa  */
  async saveAdjust() {

    this.disableWebOptions();
    this.showLoading('Guardando compulsa', 'Por favor espere.');

    let newInv = this.adjustLines.filter(x => x.LineNumber != 0);
    this.adjustLines.forEach(line => {
      newInv.push(...line.Childrens);
    });

    await this.adjustServive.saveAdjustV2(this.ActiveAdjust.AdjustCode, newInv).toPromise().then(async resp => {
      this.hideLoading();
      this.globalFunctionService.messageToast(`Inventario guardado.`, 'success');
      await this.reloadAdjust();
      this.hideLoading();
      this.adjPTRunning = true;
    })
      .catch(err => {
        this.hideLoading();
        this.showErrorMessage(err);
        this.enableSave = true;
        this.enableSign = true;
      });

  }

  /**Cierra la compulsa  */
  async closeAdjust() {
    this.disableWebOptions();
  }

  async signAdjust() {
    this.disableWebOptions();

    if (this.ActiveAdjust.Status == "SIGNED") {

      let confirmed = await this.confirmSignAdjust();
      if (!confirmed) {
        this.enableSign = true;
        this.enableReopen = true;
        return;
      }

      //Valido los archivos adjuntos antes de firmar
      let hasAtt = await this.validateAttachments();
      if (!hasAtt) {
        this.enableSign = true;
        this.enableReopen = true;
        return;
      }

      this.showLoading('Firmando compulsa', 'por favor espere');
      await this.adjustServive.signAdjust(this.ActiveAdjust.AdjustCode).toPromise().then(result => {
        this.hideLoading();
        this.globalFunctionService.messageToast(`Compulsa firmada correctamente.`, 'success');
        this.reloadAdjust();
      })
        .catch(err => {
          this.showErrorMessage(err);
          this.reloadAdjust();
        });

    }
    else {
      this.showLoading('Firmando compulsa', 'por favor espere');
      //guardo antes de firmar 
      let newInv = this.adjustLines.filter(x => x.LineNumber != 0);
      this.adjustLines.forEach(line => {
        newInv.push(...line.Childrens);
      });
      await this.adjustServive.saveAdjustV2(this.ActiveAdjust.AdjustCode, newInv).toPromise().then(async resp => {
        //firmo despues de guardar
        await this.adjustServive.signAdjust(this.ActiveAdjust.AdjustCode)
          .toPromise()
          .then(result => {
            this.hideLoading();
            this.globalFunctionService.messageToast(`Compulsa firmada correctamente.`, 'success');
            this.reloadAdjust();
          })
          .catch(err => {
            this.showErrorMessage(err);
            this.reloadAdjust();
          });

      })
        .catch(err => {
          this.hideLoading();
          this.showErrorMessage(err);
          this.reloadAdjust();
        });
    }
  }

  async reopenAdjust() {
    this.disableWebOptions();
    await this.adjustServive.reopenAdjust(this.ActiveAdjust.AdjustCode).toPromise().then(result => {
      this.globalFunctionService.messageToast(`Compulsa reabierta.`, 'success');
      this.reloadAdjust();
    })
      .catch(err => {
        this.showErrorMessage(err);
      });
  }

  async saveAdjustApk() {
    this.enableSaveAPK = false;
    this.showLoading('Guardando compulsa', 'Por favor espere.');
    let newInv = this.adjustLines.filter(x => x.LineNumber != 0);
    this.adjustLines.forEach(line => {
      newInv.push(...line.Childrens);
    });
    await this.adjustServive.saveAdjustApk(this.ActiveAdjust.AdjustCode, newInv).toPromise().then(resp => {
      this.hideLoading();
      this.globalFunctionService.messageToast(`Inventario guardado.`, 'success');
      this.reloadAdjust();
    })
      .catch(err => {
        this.hideLoading();
        this.showErrorMessage(err);
        this.enableSaveAPK = true;
      });
  }

  //#endregion

  //#region AdjustV2

  /**Actualizo las cantidades del padre para que sea la suma de los hijos */
  updateParentValue(line: AdjustUnitCutLine, children: AdjustUnitCutLineDetail) {
    let lineContainer = line.Detail.find(x => x.ContainerId == children.ContainerId);
    let detailSum = 0;
    for (let index = 0; index < line.Childrens.length; index++) {
      const currentChildren = line.Childrens[index];
      let childrencontainer = currentChildren.Detail.find(x => x.ContainerId == children.ContainerId);
      if (childrencontainer !== null && childrencontainer !== undefined) {
        detailSum += childrencontainer.Quantity;
      }
    }

    lineContainer.Quantity = detailSum;
    this.updateTotalValue(line, lineContainer);
  }


  /**Recalcula el total de las lineas  */
  updateTotalValue(line: AdjustUnitCutLine, children: AdjustUnitCutLineDetail) {

    let updatedContainer = children.ContainerId;

    let totalPhisic = 0;
    let parentLines = this.adjustLines.filter(x => x.ParentId == 0 && x.LineNumber !== 90 && x.LineNumber !== 91 && x.LineNumber !== 95 && x.LineNumber !== 99);
    for (let index = 0; index < parentLines.length; index++) {
      const currentLine = parentLines[index];
      let currentLineContainer = currentLine.Detail.find(x => x.ContainerId == updatedContainer);
      if (currentLineContainer !== null && currentLineContainer !== undefined) {
        totalPhisic += currentLineContainer.Quantity;
      }
    }

    //inv fisico
    let phisicInv = this.adjustLines.find(x => x.LineNumber == 90);
    let phisicContainer = phisicInv.Detail.find(x => x.ContainerId == updatedContainer);
    if (phisicContainer === null || phisicContainer == undefined) {
      return;
    }
    phisicContainer.Quantity = totalPhisic;
    //env teorico
    let teoricInv = this.adjustLines.find(x => x.LineNumber == 91);
    let teoricContainer = teoricInv.Detail.find(x => x.ContainerId == updatedContainer);
    if (teoricContainer === null || teoricContainer == undefined) {
      return;
    }
    //diferencia fisico - teorico
    let diffInv = this.adjustLines.find(x => x.LineNumber == 95);
    let diffContainer = diffInv.Detail.find(x => x.ContainerId == updatedContainer);
    if (diffContainer === null || diffContainer == undefined) {
      return;
    }
    diffContainer.Quantity = phisicContainer.Quantity - teoricContainer.Quantity;
    //inv de cierre
    let closeInv = this.adjustLines.find(x => x.LineNumber == 99);
    let closeContainer = closeInv.Detail.find(x => x.ContainerId == updatedContainer);
    closeContainer.Quantity = phisicContainer.Quantity;


  }

  updateTotals() {
    let containerList = this.adjustLines.find(x => x.LineNumber == 0);
    containerList.Detail;

    for (let index = 0; index < containerList.Detail.length; index++) {
      const element = containerList.Detail[index];
      let updatedContainer = element.ContainerId;

      let totalPhisic = 0;
      let parentLines = this.adjustLines.filter(x => x.ParentId == 0 && x.LineNumber !== 90 && x.LineNumber !== 91 && x.LineNumber !== 95 && x.LineNumber !== 99);
      for (let index = 0; index < parentLines.length; index++) {
        const currentLine = parentLines[index];
        let currentLineContainer = currentLine.Detail.find(x => x.ContainerId == updatedContainer);
        if (currentLineContainer !== null && currentLineContainer !== undefined) {
          totalPhisic += currentLineContainer.Quantity;
        }
      }

      //inv fisico
      let phisicInv = this.adjustLines.find(x => x.LineNumber == 90);
      let phisicContainer = phisicInv.Detail.find(x => x.ContainerId == updatedContainer);
      if (phisicContainer === null || phisicContainer == undefined) {
        return;
      }
      phisicContainer.Quantity = totalPhisic;
      //env teorico
      let teoricInv = this.adjustLines.find(x => x.LineNumber == 91);
      let teoricContainer = teoricInv.Detail.find(x => x.ContainerId == updatedContainer);
      if (teoricContainer === null || teoricContainer == undefined) {
        return;
      }
      //diferencia fisico - teorico
      let diffInv = this.adjustLines.find(x => x.LineNumber == 95);
      let diffContainer = diffInv.Detail.find(x => x.ContainerId == updatedContainer);
      if (diffContainer === null || diffContainer == undefined) {
        return;
      }
      diffContainer.Quantity = phisicContainer.Quantity - teoricContainer.Quantity;
      //inv de cierre
      let closeInv = this.adjustLines.find(x => x.LineNumber == 99);
      let closeContainer = closeInv.Detail.find(x => x.ContainerId == updatedContainer);
      closeContainer.Quantity = phisicContainer.Quantity;

    }

  }

  //#endregion


  //#region Temporizador

  /**inicia el temporizador de la compulsa */
  async startTimer() {

    await this.adjustServive.getAdjustMaxHours().toPromise().then(resp => {
      this.countdownMaxTime = resp.Value;

      let canIncreaseTime = this.userActivities.includes('ADJCNTINCR');

      this.timer = setInterval(() => {

        //Obtengo el dia actual
        this.currentDateTime = new Date();

        //obtengo el tiempo limite para la compulsa
        let timeArr = this.ActiveAdjust.AdjustCountdown.split(':');
        //sumo el tiempo limite al tempo de creacion de la compulsa 
        this.adjLapTime = moment(this.ActiveAdjust.CreatedAt).add(timeArr[0], 'hours').add(timeArr[1], 'minutes').add(timeArr[2], 'seconds');


        //si el tiempo limite de la compulsa es menor al actual caduco la compulsa
        let difSeconds = this.adjLapTime.diff(moment(this.currentDateTime), 'milliseconds');

        if (difSeconds < 0) {
          console.log('Caduco la compulsa');
          //detengo el timer
          this.stopTimer();
          //Caduco la compulsa
          this.lapseAdjust();
          return;
        }
        let hrs = difSeconds / 1000 / 60 / 60;
        if (hrs < 0) {
          this.hours = '0';
          this.minutes = '0';
          this.seconds = '0';
          return;
        }
        let mins = hrs < 1 ? (hrs + 1 % Math.floor(hrs + 1)) * 60 : (hrs % Math.floor(hrs)) * 60;
        let secs = mins < 1 ? (mins + 1 % Math.floor(mins + 1)) * 60 : (mins % Math.floor(mins)) * 60;

        this.hours = isNaN(hrs) ? '0' : Math.floor(hrs).toString();
        this.minutes = isNaN(mins) ? '0' : Math.floor(mins).toString();
        this.seconds = isNaN(secs) ? '0' : Math.floor(secs).toString();

        if (secs < 2) {
          //Cada minuto valido si el tiempo maximo de la compulsa se actualizo
          this.adjustServive.getAdjustCountdown(this.ActiveAdjust.AdjustCode).subscribe(resp => {
            // console.log(resp.Message);
            this.ActiveAdjust.AdjustCountdown = resp.Message;
          }, error => {
            console.log(error);
          });
        }

        this.showCountdownBox = false;
        if (hrs < 1 && mins < 15 && canIncreaseTime) {
          //muestro el mensaje para aumentar el tiempo si hay una opcion disponible para aumentar
          if (this.countdown15Enabled ||
            this.countdown30Enabled ||
            this.countdown45Enabled ||
            this.countdown60Enabled) {
            this.showCountdownBox = true;
          }
        }

      }, 1000);
    })
      .catch(err => {
        console.error(err);
      });

  }

  stopTimer() {
    clearInterval(this.timer);
  }

  evaluateMAxCountDown() {

    let headerCountDown = this.ActiveAdjust.AdjustCountdown.split(':');
    let hours = toNumber(headerCountDown[0]);
    let mins = toNumber(headerCountDown[1]);

    // console.log('countdownMaxTime', this.countdownMaxTime);
    let countdownTime = this.countdownMaxTime.split(':');
    let maxCountDownHours = toNumber(countdownTime[0]);
    let maxCountDownminutes = toNumber(countdownTime[1]);

    this.countdown15Enabled = true;
    this.countdown30Enabled = true;
    this.countdown45Enabled = true;
    this.countdown60Enabled = true;

    if (hours >= maxCountDownHours) {
      this.countdown60Enabled = false;

      if (mins + 15 > maxCountDownminutes) {
        this.countdown15Enabled = false;
      }
      if (mins + 30 > maxCountDownminutes) {
        this.countdown30Enabled = false;
      }
      if (mins + 45 > maxCountDownminutes) {
        this.countdown45Enabled = false;
      }
    }
  }

  async increaseEventCountDown(minutes: number) {
    this.globalFunctionService.messageToast(`Incrementando tiempo.`, 'info');
    // this.showCountdownBox = false;

    let arr = this.ActiveAdjust.AdjustCountdown.split(':');

    if (minutes == 60) {
      arr[0] = (toNumber(arr[0]) + 1).toString();
    }
    else {
      arr[1] = (toNumber(arr[1]) + minutes).toString();
    }

    let countDown = arr.join(':');
    //actualizo tiempo en db
    await this.adjustServive.increaseEventCountdown(this.ActiveAdjust.AdjustCode, countDown).toPromise().then(() => {
      //Compulsa local
      this.ActiveAdjust.AdjustCountdown = countDown;
      let timeArr = countDown.split(':');
      this.adjLapTime = moment(this.ActiveAdjust.CreatedAt).add(timeArr[0], 'hours').add(timeArr[1], 'minutes').add(timeArr[2], 'seconds');
      this.evaluateMAxCountDown();
      this.localStartAdjustNotification();
      this.globalFunctionService.messageToast(`Tiempo incrementado.`, 'success');
    })
      .catch(err => {
        this.showErrorMessage(err);
      });


  }

  localStartAdjustNotification() {
    this.notificationService.currentMessage$.next({
      data: {
        Action: "AdjustStarted",
        CreatedAt: this.ActiveAdjust.CreatedAt,
        CountDown: this.ActiveAdjust.AdjustCountdown
      }
    })
  }


  //#endregion


  //#region firebase

  /**Actualiza la coneccion del cliente con Fiurebase */
  updateAdjustConnetions() {
    let adjustCon = {
      Org: this.user.Org,
      AdjustCode: this.ActiveAdjust.AdjustCode,
      ConnChannel: 'Event',
      FirebaseKey: this.user.Token.length > 200 ? this.user.Token.substring(0, 199) : this.user.Token,
      ConnUser: this.user.Email
    };
    this.adjustServive.updateConnection(adjustCon).toPromise().then(() => {

    })
      .catch((err) => {
        this.showErrorMessage(err);
      })

    let towerCon = {
      Org: this.user.Org,
      AdjustCode: this.ActiveAdjust.AdjustCode,
      ConnChannel: 'Tower',
      FirebaseKey: this.user.Token.length > 200 ? this.user.Token.substring(0, 199) : this.user.Token,
      ConnUser: this.user.Email
    };
    this.adjustServive.updateConnection(towerCon).toPromise().then(() => {

    })
      .catch((err) => {
        this.showErrorMessage(err);
      })


  }

  /**Inicia la coneccion con Firebase  */
  OpenFirebaseConnection() {

    this.db.database.goOnline();
    //Suscripcion a los eventos de firebase
    this.firebaseEvents = this.db.list(`${this.SelectedUnit.UnitId}/${this.ActiveAdjust.AdjustCode}/Events`);
    this.firebaseTowers = this.db.list(`${this.SelectedUnit.UnitId}/${this.ActiveAdjust.AdjustCode}/Towers`);

    //Valida el estatus de la compulsa
    this.dataState();
  }

  /**Finaliza la coneccion con firebase */
  CloseFirebaseConnection() {
    if (this.db != undefined) {
      if (this.db.database != undefined) {
        this.db.database.goOffline();
      }
    }

    if (this.eventsSub != undefined) {
      this.eventsSub.unsubscribe();
      this.eventsSub.remove(this.eventsSub);
    }
    if (this.towersSub != undefined) {
      this.towersSub.unsubscribe();
      this.towersSub.remove(this.towersSub);
    }
    this.firebaseEvents = null;
    this.firebaseTowers = null;
  }

  /**Administrador que recibe los mensajes de firebase  */
  dataState() {

    this.eventsSub = this.firebaseEvents.stateChanges().subscribe(async event => {
      if (!this.userInAdjustPage) { return; }

      //'child_added' | 'child_removed' | 'child_changed' | 'child_moved';
      if (event.type == 'child_removed') {
        this.CloseFirebaseConnection();
        return;
      }

      this.ActiveAdjust.AdjustCountdown = event.payload.val().Countdow;
      let timeArr = this.ActiveAdjust.AdjustCountdown.split(':');
      this.adjLapTime = moment(this.ActiveAdjust.CreatedAt).add(timeArr[0], 'hours').add(timeArr[1], 'minutes').add(timeArr[2], 'seconds');

      if (event.payload.val().Status == "SIGNEDAPK") {
        this.ActiveAdjust.Status = 'SIGNEDAPK';
        this.validateAdjustStatus();
      }
      else {
        this.evaluateMAxCountDown();

        //Actualizo coneccion para indicar que esta activa
        this.updateAdjustConnetions();
      }
    });

    let lastEvent = null;
    this.towersSub = this.firebaseTowers.stateChanges().subscribe(async event => {
      if (lastEvent == null) {
        lastEvent = event;
      }

      if (lastEvent.prevKey == event.prevKey) {
        console.log('event skipped');
        return;
      }
      console.log(event);
      lastEvent = event;

      if (!this.userInAdjustPage) { return; }
      if (this.gettingDetail || !this.adjApkRunning) { return; }

      this.globalFunctionService.messageToast(`Actualizando inventario.`, 'info');

      await this.reloadDetail();

      this.globalFunctionService.messageToast(`Inventario actualizado.`, 'info');

      //Actualizo coneccion para indicar que esta activa
      this.updateAdjustConnetions();

    });

  }

  //#endregion

  //#region Attachment

  /**Agregar archivos adjuntos */
  btnAttachement() {
    window.open(
      `/purchase/attachment/ceq_adjust/${this.ActiveAdjust.AdjustCode}/Compulsa/CED`,
      '_blank'
    );
  }

  /**Validar archivos adjuntos */

  async validateAttachments(): Promise<boolean> {
    return await this.purchaseService.getAttachmentList('ceq_adjust', this.ActiveAdjust.AdjustCode).toPromise().then(async (data) => {
      if (data === null) {
        await this.globalFunctionService.messageBimbo(`Es Necesario adjuntar evidencia para finalizar la compulsa.`, 'warning', 'Compulsa');
        return false;
      } else {
        return true;
      }
    });
  }

  //#endregion



}

/**Equipo controlado */
export class AdjustManagedContainer {
  ContainerId: number;
  ContainerDescription: string;
  ContainerName: string;
  ContainerCode: string;
}

/**Encabezado de las filas para la caratula */
export class AdjustUnitCutLine {
  LineNumber: number;
  Order: number;
  Description: string;
  IsHeader: boolean;
  StyleClass: string;
  ParentId: number;
  Collapsed: boolean;
  Childrens: AdjustUnitCutLine[];
  Detail: AdjustUnitCutLineDetail[];
}

/**Detalle de una linea de la caratula */
export class AdjustUnitCutLineDetail {
  Order: number;
  ContainerId: number;
  ContainerCode: string;
  Quantity: number;
  IsEditable: boolean;
}





export class AdjustDetailCut {
  CutId: string;
  Line: number;
  ContainerId: number;
  Quantity: number;
  CreatedAt: Date;
  CreatedBy: string;
  ModifiedAt: Date;
  ModifiedBy: string;
}

export class AdjustDetail {
  Org: number;
  AdjustCode: string;
  DetailId: string;
  TowerNumber: number;
  TowerStatus: string;
  ContainerLocation: string;
  ContainerCode: string;
  Quantity: number;
  Line: number;
  CreatedAt: Date;
  CreatedBy: string;
  ModifiedAt: Date;
  ModifiedBy: string;
}


export class FirebaseMessage {
  MessageId: number;
  MessageContent: string;
  Sended: Date;
  Readed: Date;
}

export class FirebaseEvent {
  UnitId: number;
  AdjustCode: string;
  CreatedAt: Date;
  Countdow: string;
  Status: string
}

export class FirebaseTowers {
  TowerNumber: number;
  Status: string;
}

export class FirebaseSeller {
  SellerLogin: string;
}